export const UsageProfileThresholdCondID = {
    inAppReview: 'inAppReview',
};
